/* PostHog loader from the DynaPaw reference; loaded only after analytics is allowed. */
function loadRevvPostHog() {
  !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="an ln init xn Cn Br kn In capture Fn nn calculateEventProperties On register register_once register_for_session unregister unregister_for_session Ln getFeatureFlag getFeatureFlagPayload getFeatureFlagResult getAllFeatureFlags isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync Dn identify setPersonProperties unsetPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset shutdown setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException addExceptionStep captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty An Rn createPersonProfile setInternalOrTestUser $n yn jn opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Tn debug Ur Rt getPageViewId captureTraceFeedback captureTraceMetric pn".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
}

(function () {
  'use strict';
  var configElement = document.getElementById('revv-analytics-config');
  if (!configElement || window.revvAnalyticsInstalled) return;
  window.revvAnalyticsInstalled = true;
  var config = JSON.parse(configElement.textContent);
  var started = false;
  var ready = false;
  var pageTracked = false;
  var optedOut = false;
  var replayScheduled = false;

  // Keep event tracking immediate; let the storefront paint before initializing replay.
  function scheduleReplay() {
    if (replayScheduled || !ready || !allowed()) return;
    replayScheduled = true;
    function start() {
      replayScheduled = false;
      if (ready && allowed()) window.posthog.startSessionRecording();
    }
    function idle() {
      if (window.requestIdleCallback) window.requestIdleCallback(start, { timeout: 1500 });
      else window.setTimeout(start, 0);
    }
    function afterPaint() {
      if (window.requestAnimationFrame && !document.hidden) {
        window.requestAnimationFrame(function () { window.requestAnimationFrame(idle); });
      } else idle();
    }
    if (document.readyState === 'complete') afterPaint();
    else window.addEventListener('load', afterPaint, { once: true });
  }

  function allowed() {
    try {
      return !!(window.Shopify && window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed());
    } catch (error) { return false; }
  }

  function variantProperties() {
    var input = document.querySelector('[data-rv-variant]:checked');
    var quantity = document.querySelector('[data-rv-qty-input]');
    var properties = { product_id: config.productId, product_title: config.productTitle, currency: config.currency };
    if (input) {
      properties.variant_id = input.value;
      properties.flavor = input.dataset.flavor;
      properties.pack_size = input.dataset.pack;
      properties.price = Number(input.dataset.price) / 100;
    }
    if (quantity) properties.quantity = Math.max(1, parseInt(quantity.value, 10) || 1);
    return properties;
  }

  function capture(name, properties) {
    if (!allowed() || !started || !window.posthog) return;
    try {
      window.posthog.capture(name, properties || {}, { send_instantly: true });
    } catch (error) { /* Tracking must never interrupt shopping or contact forms. */ }
  }

  function trackPage() {
    if (pageTracked || !ready || !allowed()) return;
    pageTracked = true;
    capture('$pageview');
    if (config.productId) capture('product_viewed', variantProperties());
  }

  function syncConsent() {
    if (!allowed()) {
      if (ready && !optedOut) {
        window.posthog.opt_out_capturing();
        window.posthog.stopSessionRecording();
        optedOut = true;
      }
      return;
    }
    if (started) {
      if (ready && optedOut) {
        window.posthog.opt_in_capturing({ captureEventName: false });
        optedOut = false;
        scheduleReplay();
      }
      trackPage();
      return;
    }
    started = true;
    loadRevvPostHog();
    window.posthog.init(config.token, {
      api_host: config.apiHost,
      ui_host: config.uiHost,
      defaults: '2026-05-30',
      person_profiles: 'identified_only',
      capture_pageview: false,
      capture_pageleave: true,
      disable_session_recording: true,
      disable_surveys: true,
      disable_product_tours: true,
      disable_conversations: true,
      autocapture: { element_allowlist: ['a', 'button'], capture_copied_text: false },
      session_recording: { maskAllInputs: true, maskTextSelector: '.rv-refund__form, .contact' },
      before_send: function (event) {
        if (!allowed()) return null;
        event.properties = Object.assign({}, event.properties, {
          site: 'revv',
          storefront: 'revv-shopify',
          theme_role: config.environment,
          page_type: config.pageType
        });
        return event;
      },
      loaded: function (instance) {
        ready = true;
        if (!allowed()) { syncConsent(); return; }
        // Shopify's current consent is authoritative, including a previous opt-out.
        instance.opt_in_capturing({ captureEventName: false });
        trackPage();
        scheduleReplay();
      }
    });
  }

  document.addEventListener('visitorConsentCollected', syncConsent);
  function loadConsent() {
    if (window.Shopify && window.Shopify.customerPrivacy) { syncConsent(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) syncConsent();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadConsent, { once: true });
  else loadConsent();

  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('button, a');
    if (!target) return;
    if (target.matches('[data-rv-flavor]')) capture('product_flavor_selected', variantProperties());
    if (target.matches('[data-rv-thumb]')) capture('product_image_selected', { image_label: target.getAttribute('aria-label') });
    if (target.matches('a[href]')) {
      var url = new URL(target.href, window.location.href);
      if (url.origin === window.location.origin && /\/checkout\/?$/.test(url.pathname)) capture('checkout_clicked');
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-rv-variant]')) capture('product_pack_selected', variantProperties());
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.matches('[data-rv-form]')) capture('add_to_cart_requested', variantProperties());
    else if (form.matches('.rv-sub__formtag')) capture('newsletter_signup_requested');
    else if (form.closest('.rv-refund__form')) capture('refund_requested');
    else if (form.matches('#ContactForm')) capture('contact_requested');
    // A checkout click is intent, not a completed checkout or purchase.
    if (event.submitter && event.submitter.name === 'checkout') capture('checkout_clicked');
  });
})();
